import { render, staticRenderFns } from "./DialogEditar.vue?vue&type=template&id=90ffb5b8"
import script from "./DialogEditar.vue?vue&type=script&lang=js"
export * from "./DialogEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports